import { navigateTo } from 'nuxt/app'
import { useUsersStore } from '~/stores/users'

export default defineNuxtRouteMiddleware((to) => {
  const userStore = useUsersStore()

  if (import.meta.client && to.name === 'account-hulpvragen-in-de-buurt') {
    if (userStore.specificUser?.foodie) {
      return navigateTo({ name: 'account' })
    }
  }
})
